import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { Resume } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
import { AuthService } from '../../../core/services/auth.service';

interface IAlert {
  id: number;
  type: string;
  message: string;
}

@Component({
  selector: 'app-resume-info',
  templateUrl: './resume-info.component.html',
  styleUrls: ['./resume-info.component.css']
})
export class ResumeInfoComponent implements OnDestroy {
  public resume: Resume = {} as Resume;
  public _interval_fn: any;
  public alerts: Array<IAlert> = [];
  constructor(
    private localStorageService: LocalStorageService,
    public authService: AuthService,
    private resumeService: ResumeService,
    private router: Router
  ) {
    const resume_id = this.localStorageService.get('resume_id');
    if (resume_id) {
      this.resumeService.getResumeById(resume_id).subscribe(res => {
        this.resume = res.Resume;
      });
    }
  }
  next () {
    this.authService.editResume(this.resume).subscribe(res => {
      this.localStorageService.set('resume_id', res.resume.id);
      const theme_id = this.localStorageService.get('theme_id') as string || 1;
      this.router.navigate(['/themes/' + theme_id]);
    })
  }
  closeAlert(alert: IAlert) {
    const index: number = this.alerts.indexOf(alert);
    this.alerts.splice(index, 1);
  }
  ngOnDestroy() {
    clearInterval(this._interval_fn);
  }
}
